import * as moment from 'moment';

class DateHelper {
  static formatDateTime(date: Date): string {
    const formattedDate = moment(date).format('DD MMMM YYYY LT');

    return formattedDate;
  }

  static formatDateTime24h(date: Date): string {
    const formattedDate = moment(date).format('DD MMMM YYYY, HH:mm');

    return formattedDate;
  }

  static formatDate(date: Date): string {
    const formattedDate = moment(date).format('DD MMMM YYYY');

    return formattedDate;
  }

  static formatString(date: string, dateFormat = 'DD MMMM YYYY'): Date {
    const formattedString = moment(date, dateFormat).toDate();

    return formattedString;
  }

  static formatTimeRange(startDate: Date, endDate: Date): string {
    return moment(startDate).format('LT') + ' - ' + moment(endDate).format('LT');
  }

  static formatDateTimeRange(startDate: Date, endDate: Date): string {
    const isSameDay = moment(startDate).isSame(moment(endDate), 'day');
    if (isSameDay) {
      return (
        moment(startDate).format('DD MMM YYYY') +
        ', ' +
        moment(startDate).format('LT') +
        ' - ' +
        moment(endDate).format('LT')
      );
    }
    return (
      moment(startDate).format('DD MMM YYYY, LT') +
      ' - ' +
      moment(endDate).format('DD MMM YYYY, LT')
    );
  }

  static formatSimpleDateTime(date: Date): string {
    if (moment(date).isSame(moment(), 'year')) {
      return moment(date).format('DD MMM, HH:mm');
    }
    return moment(date).format('DD MMM YYYY, HH:mm');
  }

  static formatDateSimpleMonthTime(date: Date): string {
    const formattedDate = moment(date).format('DD MMM YYYY LT');

    return formattedDate;
  }
}

export default DateHelper;
